<div class="profile-card-header">
  <div class="head-wrapper">
    <ng-content select="[header]">{{ header }}</ng-content>
  </div>
</div>
<div class="card-content">
  <ng-content select="[content]"></ng-content>
</div>
